
import { Prospect, Status } from "../types/prospect";
import {  KPIData } from "../types/purchaseOrder";


// Mock data for prospects
export const MOCK_PROSPECTS: Prospect[] = [
  {
    id: "p1",
    companyIcon: "AC",
    companyName: "Acme Corp",
    companySector: "Technology",
    leadRM: "Rahul Sharma",
    partnerRM: "Aditi Sharma",
    dealSize: 350000,
    source: "Website",
    engagementLetter: "Yes",
    pipeline: "Pipeline 1",
    dealType: "Leasing",
    status: "Pending",
    createdDate: "Jan 15, 2025",
    lastUpdated: "Jan 22, 2025",
    companyLogo: "https://via.placeholder.com/50",
    lenders: [
      {
        id: "l1",
        institution: "IDFC Bank",
        institutionShort: "ID",
        lenderName: "John Smith",
        product: "Lease",
        lenderRM: "Rahul Sharma",
        createdDate: "Jan 22, 2025",
        lastUpdated: "Jan 25, 2025",
        status: "Active",
      },
      {
        id: "l2",
        institution: "HDFC Bank",
        institutionShort: "HD",
        lenderName: "Mary Johnson",
        product: "Invoice",
        lenderRM: "Rahul Sharma",
        createdDate: "Jan 15, 2025",
        lastUpdated: "Jan 20, 2025",
        status: "Inactive",
      },
    ],
  },
  {
    id: "p2",
    companyIcon: "GL",
    companyName: "GlobalTech",
    companySector: "Software",
    leadRM: "Vikram Mehta",
    partnerRM: "Priya Singh",
    dealSize: 500000,
    source: "Referral",
    engagementLetter: "Yes",
    pipeline: "Pipeline 2",
    dealType: "Term Loan",
    status: "Sanctioned",
    createdDate: "Feb 3, 2025",
    lastUpdated: "Feb 10, 2025",
     companyLogo: "https://via.placeholder.com/50",
    lenders: [
      {
        id: "l3",
        institution: "Axis Bank",
        institutionShort: "AX",
        lenderName: "Robert Chen",
        product: "Term Loan",
        lenderRM: "Vikram Mehta",
        createdDate: "Feb 10, 2025",
        lastUpdated: "Feb 15, 2025",
        status: "Active",
      },
    ],
  },
  {
    id: "p3",
    companyIcon: "SL",
    companyName: "StarLight Industries",
    companySector: "Manufacturing",
    leadRM: "Arjun Kapoor",
    partnerRM: "Neha Verma",
    dealSize: 750000,
    source: "Direct",
    engagementLetter: "No",
    pipeline: "Pipeline 1",
    dealType: "Working Capital",
    status: "Disbursed",
    createdDate: "Jan 5, 2025",
    lastUpdated: "Jan 15, 2025",
     companyLogo: "https://via.placeholder.com/50",
    lenders: [
      {
        id: "l4",
        institution: "SBI Bank",
        institutionShort: "SB",
        lenderName: "David Wilson",
        product: "Working Capital",
        lenderRM: "Arjun Kapoor",
        createdDate: "Jan 10, 2025",
        lastUpdated: "Jan 12, 2025",
        status: "Active",
      },
    ],
  }
];

// Generate filter options from the mock data
export const getFilterOptions = () => {
  const options = {
    leadRM: [...new Set(MOCK_PROSPECTS.map((p) => p.leadRM))],
    partnerRM: [...new Set(MOCK_PROSPECTS.map((p) => p.partnerRM))],
    source: [...new Set(MOCK_PROSPECTS.map((p) => p.source))],
    pipeline: [...new Set(MOCK_PROSPECTS.map((p) => p.pipeline))],
    dealType: [...new Set(MOCK_PROSPECTS.map((p) => p.dealType))],
    lenderRM: [
      ...new Set(
        MOCK_PROSPECTS.flatMap((p) => p.lenders.map((l) => l.lenderRM))
      ),
    ],
  };
  return options;
};

// Mock comments
export const MOCK_COMMENTS: Record<string, string> = {
  p1: "Client is interested in expanding their tech infrastructure.",
  l1: "Showing good interest in our lease products.",
  l2: "Need to follow up regarding documentation.",
  p3: "High priority deal with potential for upsell.",
  l4: "Disbursement scheduled for next week.",
};

// Count prospects by status
export const getStatusCounts = () => {
  const counts = {
    All: MOCK_PROSPECTS.length,
    Pending: MOCK_PROSPECTS.filter((p) => p.status === "Pending").length,
    Sanctioned: MOCK_PROSPECTS.filter((p) => p.status === "Sanctioned").length,
    Disbursed: MOCK_PROSPECTS.filter((p) => p.status === "Disbursed").length,
    Rejected: MOCK_PROSPECTS.filter((p) => p.status === "Rejected").length,
  };
  return counts;
};
import { Lead, StatsData, CallTrend, RMPerformance } from '../types/crm';

export const mockLeads: Lead[] = [
  {
    id: 1,
    companyName: "TechCorp Solutions",
    name: "John Smith",
    designation: "CEO",
    phone: "+1-555-0123",
    mobile: "+1-555-0123",
    leadType: "Hot",
    leadSource: "Website",
    leadRM: "Sarah Johnson",
    totalCalls: 3,
    status: "Interested",
    nextFollowUp: "2024-12-10",
    createdAt: "2024-11-15T10:30:00Z",
    lastCallDate: "2024-12-05T14:20:00Z",
    priority: "High",
    score: 85,
    industry: "Technology",
    companySize: "Mid-Market",
    budget: 75000,
    dealValue: 75000,
    interactions: [
      {
        id: 1,
        date: "2024-11-20T09:00:00Z",
        status: "Contacted",
        reason: "Follow-up call",
        remark: "Initial contact made. Company interested in our enterprise solution. CEO wants to see a detailed proposal.",
        nextFollowUp: "2024-11-25T10:00:00Z"
      },
      {
        id: 2,
        date: "2024-11-25T10:00:00Z",
        status: "Meeting Setup",
        reason: "Meeting scheduled",
        remark: "Meeting scheduled for next week to present the proposal. Technical team will also join the call.",
        nextFollowUp: "2024-12-02T15:00:00Z"
      },
      {
        id: 3,
        date: "2024-12-02T15:00:00Z",
        status: "Interested",
        reason: "Proposal discussed",
        remark: "Proposal presented successfully. Client showed high interest and requested customization details for their workflow.",
        nextFollowUp: "2024-12-10T11:00:00Z"
      }
    ]
  },
  {
    id: 2,
    companyName: "Global Industries",
    name: "Maria Garcia",
    designation: "CTO",
    phone: "+1-555-0456",
    leadType: "Warm",
    leadSource: "LinkedIn",
    leadRM: "Mike Wilson",
    totalCalls: 2,
    status: "Meeting Setup",
    nextFollowUp: "2024-12-08",
    createdAt: "2024-11-10T14:15:00Z",
    lastCallDate: "2024-12-03T16:30:00Z",
    priority: "Medium",
    score: 72,
    industry: "Manufacturing",
    companySize: "Enterprise",
    budget: 120000,
    dealValue: 120000,
    interactions: [
      {
        id: 4,
        date: "2024-11-15T14:30:00Z",
        status: "Contacted",
        reason: "Follow-up call",
        remark: "Connected via LinkedIn recommendation. Company is evaluating multiple solutions for their digital transformation.",
        nextFollowUp: "2024-11-22T09:00:00Z"
      },
      {
        id: 5,
        date: "2024-11-22T09:00:00Z",
        status: "Meeting Setup",
        reason: "Meeting scheduled",
        remark: "Detailed discussion about their requirements. Meeting set up with decision makers for next week.",
        nextFollowUp: "2024-12-08T14:00:00Z"
      }
    ]
  },
  {
    id: 3,
    companyName: "StartupXYZ",
    name: "Alex Chen",
    designation: "Founder",
    phone: "+1-555-0789",
    leadType: "Cold",
    leadSource: "Cold Call",
    leadRM: "Lisa Brown",
    totalCalls: 1,
    status: "New",
    createdAt: "2024-12-01T09:45:00Z",
    priority: "Low",
    score: 45,
    industry: "Startup",
    companySize: "Small",
    budget: 25000,
    dealValue: 25000,
    interactions: []
  },
  {
    id: 4,
    companyName: "Enterprise Corp",
    name: "David Wilson",
    designation: "VP Sales",
    phone: "+1-555-0321",
    leadType: "Hot",
    leadSource: "Referral",
    leadRM: "John Smith",
    totalCalls: 5,
    status: "Won",
    nextFollowUp: "",
    createdAt: "2024-10-20T11:20:00Z",
    lastCallDate: "2024-11-28T10:15:00Z",
    priority: "High",
    score: 95,
    industry: "Enterprise Software",
    companySize: "Enterprise",
    budget: 200000,
    dealValue: 200000,
    interactions: [
      {
        id: 6,
        date: "2024-10-25T10:00:00Z",
        status: "Contacted",
        reason: "Follow-up call",
        remark: "Referral from existing client. High interest level from the start.",
        nextFollowUp: "2024-10-30T14:00:00Z"
      },
      {
        id: 7,
        date: "2024-11-05T14:00:00Z",
        status: "Proposal Sent",
        reason: "Proposal discussed",
        remark: "Comprehensive proposal sent after detailed requirement analysis. Client impressed with our solution fit.",
        nextFollowUp: "2024-11-12T11:00:00Z"
      },
      {
        id: 8,
        date: "2024-11-28T10:15:00Z",
        status: "Won",
        reason: "Deal closed",
        remark: "Contract signed! $200K annual deal secured. Implementation to start next month.",
        nextFollowUp: ""
      }
    ]
  },
  {
    id: 5,
    companyName: "RetailMart Inc",
    name: "Emma Thompson",
    designation: "IT Director",
    phone: "+1-555-0654",
    leadType: "Warm",
    leadSource: "Trade Show",
    leadRM: "Sarah Johnson",
    totalCalls: 4,
    status: "Lost",
    createdAt: "2024-09-15T13:10:00Z",
    lastCallDate: "2024-11-20T09:45:00Z",
    priority: "Medium",
    score: 68,
    industry: "Retail",
    companySize: "Mid-Market",
    budget: 80000,
    dealValue: 80000,
    interactions: [
      {
        id: 9,
        date: "2024-09-20T11:00:00Z",
        status: "Contacted",
        reason: "Follow-up call",
        remark: "Met at trade show. Initial interest in inventory management solution.",
        nextFollowUp: "2024-09-27T15:00:00Z"
      },
      {
        id: 10,
        date: "2024-10-10T15:00:00Z",
        status: "Proposal Sent",
        reason: "Proposal discussed",
        remark: "Detailed proposal sent after requirements gathering. Waiting for budget approval.",
        nextFollowUp: "2024-10-20T10:00:00Z"
      },
      {
        id: 11,
        date: "2024-11-20T09:45:00Z",
        status: "Lost",
        reason: "Budget constraints",
        remark: "Budget frozen for this fiscal year. They decided to postpone the project to next year.",
        nextFollowUp: ""
      }
    ]
  },
  {
    id: 6,
    companyName: "HealthTech Solutions",
    name: "Dr. Robert Lee",
    designation: "Chief Medical Officer",
    phone: "+1-555-0987",
    leadType: "Hot",
    leadSource: "Website",
    leadRM: "Mike Wilson",
    totalCalls: 2,
    status: "Not Interested",
    createdAt: "2024-11-25T16:30:00Z",
    lastCallDate: "2024-12-01T11:20:00Z",
    priority: "Low",
    score: 35,
    industry: "Healthcare",
    companySize: "Mid-Market",
    budget: 90000,
    dealValue: 90000,
    interactions: [
      {
        id: 12,
        date: "2024-11-28T14:00:00Z",
        status: "Contacted",
        reason: "Follow-up call",
        remark: "Interested in healthcare compliance solution but timing not right due to ongoing system migration.",
        nextFollowUp: "2024-12-01T11:00:00Z"
      },
      {
        id: 13,
        date: "2024-12-01T11:20:00Z",
        status: "Not Interested",
        reason: "Not interested",
        remark: "After internal discussion, decided to build in-house solution instead of purchasing external software.",
        nextFollowUp: ""
      }
    ]
  }
];

export const mockStats: StatsData[] = [
  { status: "New", count: 15 },
  { status: "Contacted", count: 8 },
  { status: "Interested", count: 12 },
  { status: "Meeting Setup", count: 6 },
  { status: "Proposal Sent", count: 4 },
  { status: "Won", count: 3 },
  { status: "Lost", count: 2 },
  { status: "Not Interested", count: 5 }
];

export const mockCallTrends: CallTrend[] = [
  { date: "2024-12-01", calls: 25, meetings: 5, deals: 2 },
  { date: "2024-12-02", calls: 32, meetings: 8, deals: 3 },
  { date: "2024-12-03", calls: 18, meetings: 3, deals: 1 },
  { date: "2024-12-04", calls: 41, meetings: 12, deals: 5 },
  { date: "2024-12-05", calls: 29, meetings: 7, deals: 2 },
  { date: "2024-12-06", calls: 35, meetings: 9, deals: 4 },
  { date: "2024-12-07", calls: 22, meetings: 4, deals: 1 }
];

export const mockRMPerformance: RMPerformance[] = [
  { name: "Sarah Johnson", todayCalls: 12, followUpCalls: 8, meetingsSetup: 3, dealsWon: 2, revenue: 150000, conversionRate: 25.5 },
  { name: "Mike Wilson", todayCalls: 15, followUpCalls: 6, meetingsSetup: 2, dealsWon: 3, revenue: 280000, conversionRate: 32.1 },
  { name: "Lisa Brown", todayCalls: 8, followUpCalls: 4, meetingsSetup: 1, dealsWon: 1, revenue: 75000, conversionRate: 18.7 },
  { name: "John Smith", todayCalls: 18, followUpCalls: 10, meetingsSetup: 4, dealsWon: 4, revenue: 320000, conversionRate: 35.2 }
];

import { Supplier, PurchaseOrder, Invoice, Asset, DashboardMetrics } from '../types/supplier';

export const mockSuppliers: Supplier[] = [
  {
    id: 'SUP001',
    companyName: 'TechCorp Solutions Pvt Ltd',
    tradeName: 'TechCorp',
    pan: 'ABCDE1234F',
    cin: 'L72200DL2023PLC123456',
    websiteUrl: 'https://techcorp.com',
    companyLogo: 'https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=64&h=64&fit=crop&crop=center',
    spocDetails: [
      {
        id: 'spoc1',
        name: 'Priya Sharma',
        mobile: '9876543211',
        email: 'priya@techcorp.com',
        designation: 'Project Manager',
        department: 'Operations',
        isPrimary:true,
      }
    ],
    createdAt: '2024-01-15',
    updatedAt: '2024-08-20',
    createdBy:1,
    poCount: 12,
    invoiceCount: 8,
    bankName: 'HDFC Bank',
    accountNumber: '12345678901234',
    accountHolderName: 'TechCorp Solutions Pvt Ltd',
    ifscCode: 'HDFC0001234',
    branchName: 'Mumbai Central',
    checkDocument: 'hdfc_cancelled_check.pdf',
    addresses: [
      {
        id: 'ADDR001',
        addressLine1: 'Plot 123, Tech Park',
        addressLine2: 'Sector 5, Navi Mumbai',
        city: 'Mumbai',
        state: 'Maharashtra',
        pincode: '400703',
        gstin: '27ABCDE1234F1Z5',
        addressType: 'Registered Office'
      }
    ]
  },
  {
    id: 'SUP002',
    companyName: 'Global Manufacturing Ltd',
    tradeName: 'GlobalMfg',
    pan: 'FGHIJ5678K',
    spocDetails: [
      {
        id: 'spoc1',
        name: 'Priya Sharma',
        mobile: '9876543211',
        email: 'priya@techcorp.com',
        designation: 'Project Manager',
        department: 'Operations',
        isPrimary:true,
      }
    ],
    websiteUrl: 'https://globalmfg.com',
    companyLogo: 'https://images.unsplash.com/photo-1560472355-536de3962603?w=64&h=64&fit=crop&crop=center',
    createdAt: '2024-02-10',
    updatedAt: '2024-08-18',
    poCount: 8,
    invoiceCount: 15,
  },
  {
    id: 'SUP003',
    companyName: 'Green Energy Systems',
    tradeName: 'GreenEnergy',
    pan: 'KLMNO9012P',
    spocDetails: [
      {
        id: 'spoc1',
        name: 'Priya Sharma',
        mobile: '9876543211',
        email: 'priya@techcorp.com',
        designation: 'Project Manager',
        department: 'Operations',
        isPrimary:true,
      }
    ],
    websiteUrl: 'https://greenenergy.com',
    companyLogo: 'https://images.unsplash.com/photo-1497435334941-8c899ee9e8e9?w=64&h=64&fit=crop&crop=center',
    createdAt: '2024-03-05',
    updatedAt: '2024-07-22',
    poCount: 3,
    invoiceCount: 2,
  },
  {
    id: 'SUP004',
    companyName: 'Digital Solutions India',
    tradeName: 'DigiSol',
    pan: 'PQRST3456U',
    spocDetails: [
      {
        id: 'spoc1',
        name: 'Priya Sharma',
        mobile: '9876543211',
        email: 'priya@techcorp.com',
        designation: 'Project Manager',
        department: 'Operations',
        isPrimary:true,
      }
    ],
    websiteUrl: 'https://digisol.com',
    companyLogo: 'https://images.unsplash.com/photo-1551434678-e076c223a692?w=64&h=64&fit=crop&crop=center',
    createdAt: '2024-04-12',
    updatedAt: '2024-08-25',
    poCount: 20,
    invoiceCount: 12,
  },

];

export const mockPurchaseOrders: PurchaseOrder[] = [
  {
    id: 'PO001',
    poNumber: 'PO-2024-001',
    date: '2024-08-01',
    status: 'Delivered',
    amount: 250000,
    supplierId: 'SUP001',
    linkedInvoices: ['INV001', 'INV002']
  },
  {
    id: 'PO002',
    poNumber: 'PO-2024-002',
    date: '2024-08-15',
    status: 'Acknowledged',
    amount: 180000,
    supplierId: 'SUP002',
  },
  {
    id: 'PO003',
    poNumber: 'PO-2024-003',
    date: '2024-08-20',
    status: 'Sent',
    amount: 320000,
    supplierId: 'SUP004',
  }
];

export const mockInvoices: Invoice[] = [
  {
    id: 'INV001',
    invoiceNumber: 'INV-2024-001',
    date: '2024-08-05',
    poId: 'PO001',
    amount: 125000,
    status: 'Paid',
    supplierId: 'SUP001'
  },
  {
    id: 'INV002',
    invoiceNumber: 'INV-2024-002',
    date: '2024-08-10',
    poId: 'PO001',
    amount: 125000,
    status: 'Pending',
    supplierId: 'SUP001'
  },
  {
    id: 'INV003',
    invoiceNumber: 'INV-2024-003',
    date: '2024-08-18',
    amount: 95000,
    status: 'Overdue',
    supplierId: 'SUP002'
  }
];

export const mockAssets: Asset[] = [
  {
    id: 'AST001',
    assetId: 'LAPTOP-001',
    assetType: 'Laptop',
    poId: 'PO001',
    leaseStatus: 'Active',
    supplierId: 'SUP001'
  },
  {
    id: 'AST002',
    assetId: 'SERVER-001',
    assetType: 'Server',
    poId: 'PO002',
    leaseStatus: 'Active',
    supplierId: 'SUP002'
  }
];

export const mockDashboardMetrics: DashboardMetrics = {
  totalSuppliers: {
    active: 4,
    inactive: 1
  },
  totalPOs: 49,
  invoiceValue: {
    billed: 2750000,
    paid: 1850000,
    pending: 900000
  },
  assetsCount: 156
};

export const mockKPIData: KPIData = {
  posRaised: { count: 8, value: 424900 },
  posApproved: { count: 5, value: 223400 },
  posPending: { count: 3, value: 235500 },
  invoicePending: { count: 5, value: 258400 },
  activePOs: { count: 7, value: 390400 },
  
  invoicesRaised: { count: 8, value: 424900 },
  invoicesPending: { count: 5, value: 258400 },
  paymentsPaid: { count: 4, value: 115900 },
  paymentsPending: { count: 4, value: 309000 },
  paymentsOverdue: { count: 2, value: 190500 },
  
  totalAssets: { count: 9, value: 424900 },
  assetsDelivered: { count: 3, value: 76900 },
  assetsPending: { count: 5, value: 303000 },
  insurancePending: { count: 2, value: 45500 },
};
